export enum AnalyticEvents {
  rowActionDeleteClicked = 'MY_LIST_TABLE_ROW_ACTION_DELETE_CLICKED',
  rowActionViewClicked = 'MY_LIST_TABLE_ROW_ACTION_VIEW_CLICKED',
  rowActionCopyLinkClicked = 'MY_LIST_TABLE_ROW_ACTION_COPY_LINK_CLICKED',
  createNewListClicked = `MY_LIST_TABLE_CREATE_NEW_LIST_CLICKED`,
}
